/**
 * Feedback is drieledig: beeld + trilling + optioneel geluid (README §Interacties).
 * Nooit alleen kleur — het beeld staat in de schermen, hier staan trilling en geluid.
 */

const PULSE = 60;
const GAP = 90;

export type FeedbackKind = 'ok' | 'warn' | 'reject';

const PATTERNS: Record<FeedbackKind, number[]> = {
  ok: [PULSE],
  warn: [PULSE, GAP, PULSE],
  reject: [PULSE, GAP, PULSE, GAP, PULSE],
};

export function vibrate(kind: FeedbackKind): void {
  const pattern = PATTERNS[kind];
  if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
    try {
      navigator.vibrate(pattern);
    } catch {
      /* een toestel dat niet trilt is geen fout */
    }
  }
}

type AudioContextConstructor = new () => AudioContext;

let audioContext: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (audioContext) return audioContext;
  const ctor = (globalThis as { AudioContext?: AudioContextConstructor }).AudioContext;
  if (!ctor) return null;
  try {
    audioContext = new ctor();
  } catch {
    audioContext = null;
  }
  return audioContext;
}

/** Kort, laag piepje. Uitschakelbaar via Instellingen (A8). */
export function beep(kind: FeedbackKind): void {
  const context = getAudioContext();
  if (!context) return;
  try {
    const now = context.currentTime;
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.frequency.value = kind === 'ok' ? 880 : kind === 'warn' ? 590 : 330;
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.09, now + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.16);
    oscillator.connect(gain).connect(context.destination);
    oscillator.start(now);
    oscillator.stop(now + 0.18);
  } catch {
    /* geluid is een extraatje, nooit een blokkade */
  }
}

export function signal(kind: FeedbackKind, soundEnabled: boolean): void {
  vibrate(kind);
  if (soundEnabled) beep(kind);
}
